import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
	code_type: Yup.string().required("Service Point Code Type 1 is required"),
	dso: Yup.string().required("DSO is required"),
	name: Yup.string().required("Name is required"),
	tso: Yup.string().required("TSO is required"),
	type: Yup.string().required("Service Point Type is required"),
});
